import React from "react"
import cx from "classnames"
import Link from "gatsby-link"

import { Chevron } from "../../identity"
import { Detail } from "../../elements"
import { GraphCms_Url, PageInfo } from "graphql-types"

type Props = {
  className?: string
  baseUrl: GraphCms_Url
  pageInfo: Pick<
    PageInfo,
    "currentPage" | "hasNextPage" | "hasPreviousPage" | "pageCount"
  >
}

const Pagination = ({ className, baseUrl, pageInfo }: Props) => {
  return (
    <div className={cx(className, "flex justify-center")}>
      <div className="w-10">
        {pageInfo.hasPreviousPage && (
          <Link
            to={
              pageInfo.currentPage === 2
                ? `${baseUrl.pathname}`
                : `${baseUrl.pathname}/sayfa/${pageInfo.currentPage - 1}`
            }
            className="h-full flex flex-row p-4"
          >
            <Chevron
              width={8}
              fill="#3E3E3E"
              className="transform rotate-180"
            />
          </Link>
        )}
      </div>

      <Detail className="inline-block p-3 font-base">
        <span>
          {pageInfo.currentPage} / {pageInfo.pageCount}
        </span>
      </Detail>

      <div className="w-10">
        {pageInfo.hasNextPage && (
          <Link
            to={`${baseUrl.pathname}/sayfa/${pageInfo.currentPage + 1}`}
            className="h-full flex flex-row p-4"
          >
            <Chevron width={8} fill="#3E3E3E" />
          </Link>
        )}
      </div>
    </div>
  )
}

export default Pagination
